// frontend/src/components/common/Leaderboard.js
import React, { useState } from 'react';
import { fmt } from './CommonComponents';

function Leaderboard({ data, currentUserEmail, showReset, onReset, loading }) {
  const [view,       setView]       = useState("current");
  const [resetForm,  setResetForm]  = useState(false);
  const [period,     setPeriod]     = useState("");
  const [winner,     setWinner]     = useState("");
  const [submitting, setSubmitting] = useState(false);
 
  const handleReset = async () => {
    if (!period) { alert("Enter a period label e.g. April 2026"); return; }
    if (!window.confirm(`Reset the leaderboard for "${period}"?\n\nEarnings carry over. Rankings reset.`)) return;
    setSubmitting(true);
    await onReset({ periodLabel: period, winnerEmail: winner });
    setSubmitting(false);
    setResetForm(false); setPeriod(""); setWinner("");
    setView("hof");
  };
 
  const rankClass = i => i===0?"gold":i===1?"silver":i===2?"bronze":"";
 
  // data shape from the fixed backend:
  // { current:[], allTime:[], hallOfFame:[], currentPeriod:"", lastResetDate }
  const list = view==="current" ? (data?.current||[]) : view==="alltime" ? (data?.allTime||[]) : [];
 
  return (
    <div>
      <div className="tab-switch">
        <button className={view==="current"?"active":""} onClick={()=>setView("current")}>
          📅 {data?.currentPeriod||"Current Period"}
        </button>
        <button className={view==="alltime"?"active":""} onClick={()=>setView("alltime")}>🏅 All Time</button>
        <button className={view==="hof"?"active":""} onClick={()=>setView("hof")}>🏆 Hall of Fame</button>
      </div>
 
      {(view==="current"||view==="alltime") && (
        <>
          {data?.lastResetDate && view==="current" && (
            <p style={{ fontSize:11,color:"#9ca3af",marginBottom:10 }}>
              Period started: {new Date(data.lastResetDate).toLocaleDateString("en-NG",{day:"numeric",month:"long",year:"numeric"})}
            </p>
          )}
          {loading ? <div className="spinner">Loading...</div>
           : list.length===0
             ? <div style={{ textAlign:"center",padding:32,color:"#9ca3af",fontSize:13 }}>
                 <div style={{ fontSize:40,marginBottom:8 }}>🏅</div>
                 No ambassador activity yet. Orders and walk-in sales tagged to ambassadors will appear here.
               </div>
             : list.map((a,i)=>(
               <div key={a.email} className="rank-row">
                 <div className={`rank-num ${rankClass(i)} ${a.email===currentUserEmail?"rank-me":""}`}>{i+1}</div>
                 <div style={{ flex:1 }}>
                   <div style={{ fontWeight:600,fontSize:13 }}>
                     {a.name}
                     {a.email===currentUserEmail&&<span style={{ color:"#e94560",fontSize:11,marginLeft:6 }}>(You)</span>}
                   </div>
                   <div style={{ fontSize:11,color:"#6b7280" }}>
                     {a.totalActivities} activities · {a.orderCount} orders · {a.walkInCount} walk-ins · Sales: {fmt(a.totalSales)}
                   </div>
                 </div>
                 <div style={{ textAlign:"right" }}>
                   <div style={{ fontWeight:700,color:"#10b981",fontSize:13 }}>{fmt(a.totalEarned)}</div>
                   <div style={{ fontSize:10,color:"#9ca3af" }}>earned</div>
                 </div>
               </div>
           ))}
        </>
      )}
 
      {view==="hof" && (
        <>
          {(data?.hallOfFame||[]).length===0
            ? <p style={{ color:"#9ca3af",fontSize:13,textAlign:"center",padding:24 }}>No past periods yet. Reset the leaderboard at end of each month to build your Hall of Fame.</p>
            : (data.hallOfFame||[]).map(snap=>(
              <div key={snap.snapshotId} className="hof-card">
                <div className="hof-winner">
                  <div className="hof-trophy">🏆</div>
                  <div>
                    <div style={{ fontWeight:700,fontSize:14 }}>{snap.winnerName}</div>
                    <div style={{ fontSize:12,color:"#6b7280" }}>{snap.periodLabel}</div>
                    <div style={{ fontSize:12,color:"#10b981",fontWeight:600 }}>{fmt(snap.winnerSales)} sales · {fmt(snap.winnerEarning)} earned</div>
                  </div>
                  <span className="winner-badge">🥇 Champion</span>
                </div>
                <details style={{ fontSize:12,color:"#6b7280" }}>
                  <summary style={{ cursor:"pointer",userSelect:"none" }}>View full standings ({snap.standings?.length} ambassadors)</summary>
                  <div style={{ marginTop:8 }}>
                    {snap.standings?.map(s=>(
                      <div key={s.email} style={{ display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid #f3f4f6" }}>
                        <span>#{s.rank} {s.name}</span><span>{fmt(s.totalSales)}</span>
                      </div>
                    ))}
                  </div>
                </details>
                <div style={{ fontSize:11,color:"#9ca3af",marginTop:6 }}>Reset on {new Date(snap.resetDate).toLocaleDateString("en-NG",{day:"numeric",month:"long",year:"numeric"})}</div>
              </div>
            ))
          }
        </>
      )}
 
      {showReset && (
        <div style={{ marginTop:16 }}>
          {!resetForm
            ? <button className="btn btn-gold" onClick={()=>setResetForm(true)}>🔄 Reset Leaderboard (End of Period)</button>
            : (
              <div style={{ background:"#fff8ed",border:"1px solid #f5a623",borderRadius:10,padding:14 }}>
                <h3 style={{ marginBottom:10,color:"#92400e" }}>🔄 Reset Leaderboard</h3>
                <p style={{ fontSize:12,color:"#6b7280",marginBottom:12 }}>Rankings reset. Earnings carry over. Snapshot saved to Hall of Fame.</p>
                <div className="form-group">
                  <label>Period Label * (e.g. "April 2026")</label>
                  <input value={period} onChange={e=>setPeriod(e.target.value)} placeholder="April 2026"/>
                </div>
                <div className="form-group">
                  <label>Winner's Email (optional — defaults to #1 ranked)</label>
                  <input value={winner} onChange={e=>setWinner(e.target.value)} placeholder="ambassador@email.com"/>
                </div>
                <div style={{ display:"flex",gap:8 }}>
                  <button className="btn btn-gold" onClick={handleReset} disabled={submitting}>{submitting?"Resetting...":"🏆 Confirm Reset & Crown Winner"}</button>
                  <button className="btn btn-secondary" onClick={()=>setResetForm(false)}>Cancel</button>
                </div>
              </div>
            )
          }
        </div>
      )}
    </div>
  );
}

export default Leaderboard;